export default __webpack_public_path__ + "static/media/M22.90a5a7e8.svg";